<template>
  <require from="framework/value_converters/date-and-time"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-lookup"></require>
  <require from="controls/as-form-widget.html"></require>

  <div class="wg-city-segment">
    <as-form-widget heading="Where are you travelling to?" countryicon.bind="widgetIcon">
      <div slot="default">
        <div class="form-row">
          <div class="col-sm-6 col-xl-3 order-sm-0 order-xl-0">
            <bs-form-lookup label="City of stay" placeholder="Look it up" item.bind="model.city & validate" options.bind="citiesLookupOptions" value-path="name" stick-mode="true" template-path="templates/city-lookup.html" disabled.bind="controller.disabled" tooltip="Type to search for destination or nearby city, then pick the one from the list" maxlength="100"></bs-form-lookup>
          </div>
          <div class="col-sm-6 col-xl-3 order-sm-2 order-xl-1">
            <bs-form-input type="text" label="Country" value.bind="countryName" disabled="true"></bs-form-input>
          </div>
          <div class="col-sm-6 col-xl-3 order-sm-1 order-xl-2">
            <bs-form-input type="date" label="Arrival date" value.bind="model.arrivalDate | dateInput & validate" min.bind="today" max.bind="maxDate" disabled.bind="controller.disabled"></bs-form-input>
          </div>
          <div class="col-sm-6 col-xl-3 order-sm-3 order-xl-3">
            <bs-form-input type="date" label="Departure date" value.bind="model.departureDate | dateInput & validate" min.bind="today" max.bind="maxDate" disabled.bind="controller.disabled"></bs-form-input>
          </div>
        </div>
      </div>
    </as-form-widget>
  </div>
</template>
